import React, { Component, PropTypes } from 'react';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { connect } from 'react-redux';
import { range } from 'lodash';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import BackgroundPicker from '../../../widgets/BackgroundPicker';

const prefix = 'buttons.button';

class DisabledButtonStyles extends Component {
    render() {
        const border = this.props.colors.border.split(' ');
        return (
            <div className="ButtonStyles">
                <h4>{this.props.tagNameName}</h4>
                <div>{this.props.children}</div>
                <div className="row">
                    <div className="col-lg-2 col-xs-12 col-sm-8">
                        <div className="row">
                            <div className="col-sm-12">FONT COLOR</div>
                            <div className="col-sm-12">
                                <PresetColorPicker
                                    color={this.props.colors.color}
                                    isDisabled={this.props.isDisabled}
                                    onColorChange={this.props.onFontColorChange(this.props.layer, this.props.tagName)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-xs-12 col-sm-8">
                        <div className="row">
                            <div className="col-lg-12">BACKGROUND</div>
                            <div className="col-lg-12">
                                <BackgroundPicker
                                    background={this.props.colors.background}
                                    preset={this.props.themeColors.primary.colors}
                                    isDisabled={this.props.isDisabled}
                                    onChange={property =>
                                        this.props.onBackgroundColorChange(
                                            this.props.layer,
                                            this.props.tagName
                                        )({
                                            target: {
                                                value: property
                                            }
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12 col-xs-12 col-sm-6" style={{ marginTop: '25px' }}>
                        <h4>Border for Disabled Button</h4>
                        <div className="row">
                            <div className="ThemeColorRow col-lg-2 col-sm-1">
                                <ReactSparkSelectInput
                                    isDisabled={this.props.isDisabled}
                                    label="Width"
                                    values={range(20).map(v => ({ key: `${v}px`, label: `${v}px` }))}
                                    onChange={this.props.onBorderUpdate(border, 0)}
                                    defaultValue={border[0]}
                                />
                            </div>
                            <div className="ThemeColorRow col-lg-2 col-sm-1">
                                <ReactSparkSelectInput
                                    isDisabled={this.props.isDisabled}
                                    label="Style"
                                    values={[
                                        'solid',
                                        'dotted',
                                        'dashed',
                                        'double',
                                        'groove',
                                        'ridge',
                                        'inset',
                                        'outset',
                                        'none',
                                        'hidden'
                                    ].map((v, k) => ({ key: v.toString(), label: v.toString() }))}
                                    onChange={this.props.onBorderUpdate(border, 1)}
                                    defaultValue={border[1]}
                                />
                            </div>
                            <div className="ThemeColorRow col-lg-2 col-sm-1">
                                <div>Color</div>
                                <div>
                                    <PresetColorPicker
                                        color={border[2]}
                                        isDisabled={this.props.isDisabled}
                                        onColorChange={this.props.onBorderUpdate(border, 2)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DisabledButtonStyles.propTypes = {
    children: PropTypes.element,
    settings: PropTypes.object,
    tagNameName: PropTypes.string,
    isDisabled: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.app.data.theme.buttons[ownProps.layer],
        ...state.theme.buttons,
        themeColors: state.app.data.theme.colors
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFontChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_FONT,
                    layer: layer,
                    target: target,
                    font: event.target.value
                });
        },
        onFontSizeChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_FONT_SIZE,
                    layer: layer,
                    target: target,
                    size: event.target.value
                });
        },
        onFontWeightChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_FONT_WEIGHT,
                    layer: layer,
                    target: target,
                    weight: event.target.value
                });
        },
        onFontStyleChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_FONT_STYLE,
                    layer: layer,
                    target: target,
                    style: event.target.value
                });
        },
        onFontColorChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_DISABLED_FONT_COLOR,
                    layer: layer,
                    target: target,
                    color: event.target.value
                });
        },
        onBackgroundColorChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_DISABLED_BACKGROUND_COLOR,
                    layer: layer,
                    target: target,
                    color: event.target.value
                });
        },
        onTextAlignChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_TEXT_ALIGN,
                    layer: layer,
                    target: target,
                    align: event.target.value
                });
        },
        onBorderWidthChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_BORDER_WIDTH,
                    layer: layer,
                    target: target,
                    borderWidth: event.target.value
                });
        },
        onBorderStyleChange: (layer, target) => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_BUTTONS_SET_BORDER_STYLE,
                    layer: layer,
                    target: target,
                    borderStyle: event.target.value
                });
        },
        onBorderUpdate: (border, index) => {
            const value = border;
            return event => {
                value[index] = event.target.value;
                return dispatch(ThemeActions.modifyThemeKey(`${prefix}.disabled.border`, value.join(' ')));
            };
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DisabledButtonStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/buttons/DisabledButtonStyles.js